module.exports = __webpack_public_path__ + "img/white.1a0966d0.svg";